export enum XpoFacetFilterTypeControls {
  Enum,
  Option,
  RangeMinMax,
  QuickSearch,
  DateRange,
  TimeRange,
}
